import { Building, Login, Password, UserMultiple } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Вход, восстановление доступа, экран после входа и регистрация клиники (4.1, ПОРТ-10, ПОРТ-16,
 * ПОРТ-21…23, ПОРТ-42). Публичные экраны без навигации; второй фактор — экран оболочки /login/mfa.
 */
export const sections = [
  defineSection({
    id: 'auth.login',
    area: 'public',
    path: 'login',
    roles: [],
    icon: Login,
    titleKey: 'signin:login.pageTitle',
    namespaces: ['portal'],
    order: 0,
    nav: false,
    load: () => import('./LoginPage'),
  }),
  defineSection({
    id: 'auth.recovery',
    area: 'public',
    path: 'recovery',
    roles: [],
    icon: Password,
    titleKey: 'signin:recovery.title',
    namespaces: ['portal'],
    order: 1,
    nav: false,
    load: () => import('./RecoveryPage'),
  }),
  defineSection({
    id: 'auth.welcome',
    area: 'public',
    path: 'welcome',
    roles: [],
    icon: UserMultiple,
    titleKey: 'signin:welcome.pageTitle',
    namespaces: ['portal'],
    order: 2,
    nav: false,
    load: () => import('./WelcomePage'),
  }),
  defineSection({
    id: 'org.register',
    area: 'public',
    path: 'register-clinic',
    roles: [],
    icon: Building,
    titleKey: 'signin:clinic.title',
    namespaces: ['portal'],
    order: 3,
    nav: false,
    load: () => import('./RegisterClinicPage'),
  }),
];
